import i18next, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { CONFIG } from '../constants';
import enTranslation from './translations/en.json';
import deTranslation from './translations/de.json';
import enMattressTranslation from './translations/en_mattress.json';
import deMattressTranslation from './translations/de_mattress.json';
import { LANGUAGE } from '../resources/enums';

export const allLangs = [
  { name: 'English', value: 'en' },
  { name: 'Deutsch', value: 'de' },
];

export const resources = {
  en: {
    translation: enTranslation,
  },
  de: {
    translation: deTranslation,
  },
};

export const mattressResources = {
  en: {
    translation: enMattressTranslation,
  },
  de: {
    translation: deMattressTranslation,
  },
};

/**
 * Switch i18n resources based on whether user is MATRATZEN_EXPERT
 */
export const switchTranslationResources = (isMattressExpert: boolean, language: string = LANGUAGE.EN) => {
  const languages = Object.keys(resources);
  const newResources = isMattressExpert ? mattressResources : resources;

  languages.forEach((lang) => {
    i18next.addResourceBundle(
      lang,
      'translation',
      newResources[lang as keyof typeof newResources].translation,
      false, // deep = false: replace completely instead of deep merge
      true, // overwrite = true: replace existing bundle
    );
  });

  // Force language reload to ensure UI updates with new translations
  i18next.changeLanguage(language);
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Standard language used
    fallbackLng: 'en',
    debug: CONFIG.DEBUG,
    // Deep clone resources to avoid modifying the original object
    resources: JSON.parse(JSON.stringify(resources)),
    // Detects and caches a cookie from the language provided
    detection: {
      order: ['localStorage'],
      cache: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  } as InitOptions);

export default i18next;
